import styles from "@/components/common/styles/unfilled-button.module.scss";
import React from "react";
import { Property } from "csstype";
import useHover from "@/hooks/use-hover";

type Props = {
  text: string;
  textColor?: string;
  textHoveringColor?: string;
  textDisabledColor?: string;
  onClick?: () => void;
  borderColor?: Property.BorderColor;
  padding?: Property.Padding;
  disabled?: boolean;
  textTransform?: Property.TextTransform;
};

const UnfilledButton = ({
  text,
  textColor,
  textHoveringColor,
  textDisabledColor,
  onClick,
  padding,
  borderColor,
  disabled,
  textTransform,
}: Props) => {
  const { isHovering, onMouseLeave, onMouseEnter } = useHover();
  return (
    <button
      className={styles.button}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      disabled={disabled}
      style={{
        borderColor: disabled ? "#3f3f3f" : borderColor ?? "#E64C4C",
        color: disabled
          ? textDisabledColor ?? "#3f3f3f"
          : isHovering
            ? textHoveringColor ?? "#141414"
            : textColor ?? borderColor ?? "#E64C4C",
        backgroundColor: isHovering ? borderColor ?? "#E64C4C" : "transparent",
        padding: padding ?? "8px 16px",
        textTransform: textTransform ?? "none",
      }}
    >
      {text}
    </button>
  );
};

export default UnfilledButton;
